module.exports = __webpack_public_path__ + "img/link-small.235a1a37.svg";